import { UserLoginParams } from '@/types/user';
import axiosInstance from './axiosInstance';
import { BaseResponse } from '@/types/common';

/**
 * 根据code获取用户信息
 * @param code
 * @returns
 * */
export const getUserInfo = async (code: string) => {
  const response = await axiosInstance.post(
    `${SUPP_ADMIN_BASE_URL}/supp-management/callback/v1/lark/user_access_token`,
    { code }
  );
  return response.data;
};

/**
 * 登录接口
 * @param data
 * @see https://test-yapi.supptech.net/project/42/interface/api/766
 */
export const login = async (data: UserLoginParams) => {
  const response = await axiosInstance.post(
    `${SUPP_APP_GATEWAY_URL}/user-center/u/v1/login`,
    data
  );
  return response.data;
};

/**
 * 上传图片接口
 * @param data
 */
export const uploadImage = async (data: FormData) => {
  // 不设置 Content-Type，axios 会自动处理
  const response = await axiosInstance.post<BaseResponse<string>>(
    `${SUPP_APP_GATEWAY_URL}/artwork-content/amazons3/uploadImage`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

/**
 * 获取用户信息
 * /admin/v1/detail
 */
export const getUserDetail = async () => {
  const response = await axiosInstance.get(
    `${SUPP_ADMIN_BASE_URL}/supp-management/admin/v1/detail`
  );
  return response.data;
};

/**
 * 批量更新用户类型
 * @param data
 */
export const batchUpdateUserType = async (data: {
  userIds: string[];
  userType: number;
}): Promise<{
  status: number;
  success: boolean;
  message: string;
  data: boolean;
}> => {
  const response = await axiosInstance.post(
    `${SUPP_ADMIN_BASE_URL}/supp-management/review/user/update/userType`,
    data
  );
  return response.data;
};

interface UserArtworkStatistic {
  createTime: number;
  email: string | null;
  suppId: number;
  artworkCount: number;
}

interface UserArtworkStatisticResponse {
  total: number;
  currentPage: number;
  pageSize: number;
  records: UserArtworkStatistic[];
}

export interface UserArtworkStatisticParams {
  createTimeStart?: number;
  createTimeEnd?: number;
  currentPage?: number;
  pageSize?: number;
}

/**
 * 获取用户注册及作品统计数据
 */
export const getUserArtworkStatistic = async (
  params: UserArtworkStatisticParams
): Promise<{
  data: UserArtworkStatisticResponse;
  status: number;
  success: boolean;
  message: string;
}> => {
  const res = await axiosInstance.post<{
    data: UserArtworkStatisticResponse;
    status: number;
    success: boolean;
    message: string;
  }>(
    `${SUPP_ADMIN_BASE_URL}/supp-management/user/statistic/artwork/count`,
    params
  );

  return res.data;
};

/**
 * 批量更新用户限额状态
 * @param data
 */
export const batchUpdateUserLimit = async (data: {
  userIds: string;
  enableLimit: number;
}): Promise<{
  status: number;
  success: boolean;
  message: string;
  data: boolean;
}> => {
  const response = await axiosInstance.post(
    `${SUPP_ADMIN_BASE_URL}/supp-management/review/user/limit`,
    data
  );
  return response.data;
};

/**
 * 获取限额人数
 * /admin/v1/detail
 */
export const getSelectLimitUserNum = async () => {
  const response = await axiosInstance.get(
    `${SUPP_ADMIN_BASE_URL}/supp-management/review/user/selectLimitUserNum`
  );
  return response.data;
};
